import {Component, input, InputSignal, InputSignalWithTransform, model, ModelSignal, OutputRef, signal} from '@angular/core';
import {DisabledReason, FormValueControl, ValidationError, WithOptionalField} from '@angular/forms/signals';
import {FormsModule} from '@angular/forms';
import {Select} from 'primeng/select';

@Component({
  selector: 'app-select-field',
  imports: [
    FormsModule,
    Select
  ],
  templateUrl: './select-field.html',
  styleUrl: './select-field.css',
})
export class SelectField<T> implements FormValueControl<T | null> {
  value = model<T | null>(null);
  options = input<any[]>([])
  readonly = input(false);

}
